import { S, V } from "src/shared-styles";

export default {
  V,
  S,
  ...S.tab,
};
